var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pngUrl)?_c('img',{staticClass:"goodLeft",attrs:{"src":_vm.pngUrl,"alt":""}}):_c('img',{staticClass:"goodLeft",attrs:{"src":require("@/assets/img/notPng.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }